module.exports = __webpack_public_path__ + "static/media/onboard-1-create-board.2804da88.gif";